import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TokenModel } from '../models/identification/token.model';
import { ConfigService } from '../services/config/config.service';
import { LocalStorageTokenService } from '../services/utilisateurs/local-storage-token.service';

@Injectable({
  providedIn: 'root',
})
export class JwtInterceptorService implements HttpInterceptor {
  constructor(private localStorage: LocalStorageTokenService, private configService: ConfigService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newReq = req;
    if(req.url.includes('LoginWithFusionAuth')){
      return next.handle(req);
    }

    const token = this.localStorage.getCurrentToken();
    const tokenRight = this.localStorage.getCurrentAuthorizationToken();
    if (token && this.configService.isFusionAuthConfigured()) {
      newReq = req.clone({setHeaders: {Authorization: `Bearer ${token.value}`, Authorizations: `${tokenRight.value}`}});
    }
    if (token && !this.configService.isFusionAuthConfigured()) {
      newReq = req.clone({ setHeaders: { Authorization: `Bearer ${token.value}` } });
    }
    return next.handle(newReq).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          if (event.headers.get('Authorizations') !== null) {
            let headers: string = event.headers.get('Authorizations');
            let tokenModel: TokenModel = { value: headers };
            this.localStorage.setCurrentAuthorizationToken(tokenModel);
          }
        }
      })
    );
  }
}
